export default "__VITE_ASSET__DyuwLCnH__"